import { render, staticRenderFns } from "./editPage.vue?vue&type=template&id=181a825f&scoped=true"
import script from "./editPage.vue?vue&type=script&lang=js"
export * from "./editPage.vue?vue&type=script&lang=js"
import style0 from "./editPage.vue?vue&type=style&index=0&id=181a825f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a825f",
  null
  
)

export default component.exports